import { Modal } from '@forecast-it/design-system';
import React from 'react';
const GoogleOAuthErrorModal = ({ errorMessage, closeModal }) => {
    return (React.createElement(Modal, { onCloseModal: closeModal },
        React.createElement(Modal.Title, null, "Google Calendar Authorization Error"),
        React.createElement(Modal.Content, null, errorMessage)));
};
export default GoogleOAuthErrorModal;
